// extracted by mini-css-extract-plugin
module.exports = {"section":"D_section__4KZ1U"};